import { Avatar, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing } from "components";
import GenderIcon from 'components/GenderIcon';
import moment from 'moment';
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  },
  avatar: {
    height: 40,
    width: 40,
    marginRight: theme.spacing(2)
  },
  avatarbox: {
    display: "flex",
    flexDirection: "row"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Birthdate</TableCell>
            <TableCell>XP</TableCell>
            <TableCell>Active Mastery</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map((student, index) => (
            <TableRow key={index}>
              <TableCell className={clsx(classes.header, classes.avatarbox)}>
                <Avatar
                  className={classes.avatar}
                  src={student.main_image ? student.main_image.uri : "/images/avatars/placeholder_avatar.png"}
                />
                <div>
                  <div>{student.name_en}{student.name_zh ? " " + student.name_zh : ""}<GenderIcon gender={student.gender} /></div>
                  <div><Typography variant="caption">Student</Typography></div>
                </div>
              </TableCell>
              <TableCell>
                {student.birthdate && moment(student.birthdate).format("DD/MM/YYYY")}
              </TableCell>
              <TableCell>
                {student.xp_obtained || "0"}
                <div><Typography variant="caption">Total XP</Typography></div>
              </TableCell>
              <TableCell>
                {student.active_mastery_level &&
                  <Fragment>
                    {student.active_mastery_level.name_en}{student.active_mastery_level.name_zh ? " " + student.active_mastery_level.name_zh : ""}
                    <div><Typography variant="caption">{`${(student.active_mastery_level.user_mastery_level && student.active_mastery_level.user_mastery_level.xp_obtained) || "0"}/${student.active_mastery_level.xp_complete} XP`}</Typography></div>
                  </Fragment>
                }
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`students/${student.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;